import { Suspense, lazy } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useSessao } from './sessao.jsx'
import { Carregando } from './componentes/basicos.jsx'
import Entrar from './telas/Entrar.jsx'
import DefinirSenha from './telas/DefinirSenha.jsx'
import TrocarSenha from './telas/TrocarSenha.jsx'
import Inicio from './telas/Inicio.jsx'
import Abastecer from './telas/Abastecer.jsx'
import Garagem from './telas/Garagem.jsx'
import NovoVeiculo from './telas/NovoVeiculo.jsx'

// A tela de estatísticas é a única que carrega o Recharts (~500 kB). Deixá-la em
// carregamento tardio mantém leve o caminho mais usado — abrir o app e lançar.
const Veiculo = lazy(() => import('./telas/Veiculo.jsx'))
import Registros from './telas/Registros.jsx'
import Configuracoes from './telas/Configuracoes.jsx'
import Admin from './telas/Admin.jsx'

/**
 * Portão de acesso. A troca de senha pendente (SPEC §3.1) é espelhada aqui:
 * o backend já bloqueia tudo com 403, e a interface leva direto para a tela certa
 * em vez de deixar a pessoa esbarrar em erro atrás de erro.
 */
function Protegida({ children }) {
  const { usuario, carregando } = useSessao()
  const local = useLocation()

  if (carregando) return <Carregando />
  if (!usuario) return <Navigate to="/entrar" replace state={{ de: local.pathname }} />
  if (usuario.senha_precisa_troca && local.pathname !== '/trocar-senha') {
    return <Navigate to="/trocar-senha" replace />
  }
  return children
}

function SomenteAdmin({ children }) {
  const { usuario } = useSessao()
  return usuario?.papel === 'admin' ? children : <Navigate to="/" replace />
}

export default function App() {
  return (
    <Routes>
      <Route path="/entrar" element={<Entrar />} />
      <Route path="/definir-senha" element={<DefinirSenha />} />

      <Route path="/trocar-senha" element={<Protegida><TrocarSenha /></Protegida>} />
      <Route path="/" element={<Protegida><Inicio /></Protegida>} />
      <Route path="/abastecer" element={<Protegida><Abastecer /></Protegida>} />
      {/* Antes da rota com parâmetro: "novo" é segmento fixo, não um id. */}
      <Route path="/veiculos/novo" element={<Protegida><NovoVeiculo /></Protegida>} />
      <Route path="/veiculos/:id" element={
        <Protegida>
          <Suspense fallback={<Carregando />}><Veiculo /></Suspense>
        </Protegida>
      } />
      <Route path="/garagem" element={<Protegida><Garagem /></Protegida>} />
      <Route path="/registros" element={<Protegida><Registros /></Protegida>} />
      <Route path="/config" element={<Protegida><Configuracoes /></Protegida>} />
      <Route path="/admin" element={<Protegida><SomenteAdmin><Admin /></SomenteAdmin></Protegida>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
